// using module.exports here so gatsby-config can read it
module.exports = {
  builderAPIKey: "43351a561492454182b88f3ccc11f48a" // Use client's public builder.io key
};
